/**
 * Used on home page and drill down
 *
 * @format
 */
import axiosInstance from './axios';

export async function getDrillDownCharts(payload, query, expanded = false) {
  const response = await axiosInstance.post(
    `/api/v2.4/dynamic/charts/?vector=${query.toLowerCase()}&expanded=${expanded}`,
    payload
  );
  return response;
}

async function getRevenueCharts(payload) {
  const response = await axiosInstance.post(
    '/retailware_js/dynamic/rev/v2.2',
    payload
  );
  return response;
}

async function getVolumeCharts(payload) {
  const response = await axiosInstance.post(
    '/retailware_js/dynamic/vol/v2.2',
    payload
  );
  return response;
}

async function getMarginCharts(payload) {
  const response = await axiosInstance.post(
    '/retailware_js/dynamic/margin/v2.2',
    payload
  );
  return response;
}

// Get expanded charts.
async function getRevenueExpCharts(payload) {
  const response = await axiosInstance.post(
    '/retailware_js/expanded/rev/v2.2',
    payload
  );
  return response;
}

async function getVolumeExpCharts(payload) {
  const response = await axiosInstance.post(
    '/retailware_js/expanded/vol/v2.2',
    payload
  );
  return response;
}

async function getMarginExpCharts(payload) {
  const response = await axiosInstance.post(
    '/retailware_js/expanded/margin/v2.2',
    payload
  );
  return response;
}

async function getAttributeNames(payload) {
  const userDetails = JSON.parse(localStorage.getItem('USER_DETAILS'));
  const response = await axiosInstance.post('/get_attribute_names', {
    ...payload,
    Account_Id: userDetails?.account_id,
  });
  return response;
}

async function getAttributeValues(payload, module) {
  const moduleQuery = module
    ? `?module=${encodeURIComponent(module)}`
    : '';
  const response = await axiosInstance.post(
    `/api/v2.2/get_attribute_values${moduleQuery}`,
    payload
  );
  return response;
}

// KPI
async function getKPIData(payload) {
  const response = await axiosInstance.post('/retailware_kpi/v1.6', payload);
  return response;
}

export {
  getRevenueExpCharts,
  getVolumeExpCharts,
  getMarginExpCharts,
  getRevenueCharts,
  getVolumeCharts,
  getMarginCharts,
  getAttributeNames,
  getAttributeValues,
  getKPIData,
};
